import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeCN from '../views/cn/Home-CN.vue'
import CompanyCN from '../views/cn/companyCN.vue'
import ProductCN from '../views/cn/productCN.vue'
import ContactCN from '../views/cn/contactCN.vue'
import HomeEN from '../views/en/Home-EN.vue'
import CompanyEN from '../views/en/companyEN.vue'
import ProductEN from '../views/en/productEN.vue'
import ContactEN from '../views/en/contactEN.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/cn/home'
  },
  {
    path: '/cn/home',
    name: 'homeCN',
    component: HomeCN
  },
  {
    path: '/cn/company',
    name: 'companyCN',
    component: CompanyCN
  },
  {
    path: '/cn/product',
    name: 'productCN',
    component: ProductCN
  },
  {
    path: '/cn/contact',
    name: 'contactCN',
    component: ContactCN
  },
  {
    path: '/en/home',
    name: 'homeEN',
    component: HomeEN
  },
  {
    path: '/en/company',
    name: 'companyEN',
    component: CompanyEN
  },
  {
    path: '/en/product',
    name: 'productEN',
    component: ProductEN
  },
  {
    path: '/en/contact',
    name: 'contactEN',
    component: ContactEN
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
